import { ClickAwayListener, IconButton, Tooltip } from "@mui/material";
import { useState, useCallback } from "react";
import { Copy } from "lucide-react";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const CopyButton = ({
  text,
  color = nawyTheme.nawy.colors.semantic.text.primary,
  size = 16,
}: {
  text: string;
  color?: string;
  size?: number;
}) => {
  const [toolTipOpen, setToolTipOpen] = useState(false);

  const handleCopy = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation(); 
    try {
      await navigator.clipboard.writeText(text);
      setToolTipOpen(true);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  }, [text]);

  return (
    <ClickAwayListener onClickAway={() => setToolTipOpen(false)}>
      <Tooltip
        PopperProps={{ disablePortal: true }}
        onClose={() => setToolTipOpen(false)}
        open={toolTipOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title="Copied"
      >
        <IconButton color="primary" onClick={handleCopy}>
          <Copy color={color} size={size} />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default CopyButton;
